<template>
  
  <b-modal
    v-model="modalOpen"
    centered
    :title="title"
    footer-class="removed"
    class="edit-modal"
    id="activityModal"
    no-close-on-backdrop
    size="xl"
  >
    <b-card-text v-if="loadingTransictionRole">
      <b-skeleton width="10%" height="20px"></b-skeleton>
      <b-skeleton width="100%" height="40px" class="mb-2"></b-skeleton>
      <b-skeleton width="10%" height="20px"></b-skeleton>
      <b-skeleton width="100%" height="40px"></b-skeleton>
      <b-skeleton width="10%" height="30px"></b-skeleton>
      <hr/>
      <div class="d-flex align-items-end justify-content-end">
        <b-skeleton width="10%" height="30px" class="mx-1"></b-skeleton>
        <b-skeleton width="10%" height="30px"></b-skeleton>

      </div>
    </b-card-text>
   
    <b-card-text v-else>
      <validation-observer ref="activityValidation">
        <b-form @submit.prevent="saveTransictionRole">
          <b-row>
            <b-col cols="4">
              <form-select
                label="الموظف"
                v-model="ministry_user_id"
                :getOptionLabel="(x) => x.full_name"
                :reduce="(x) => x.id"
                id="programs"
                ep="v2/ministry/selects/ministry-users"
                rules="required"
                ref="programs"
              />
            </b-col>
            <b-col cols="12">
              <div  class="ml-auto d-flex justify-content-between mt-1">
                <p class="mb-0">الأدوار</p>

              </div>
              <hr />
            </b-col>
            <b-col cols="12">
              <b-row v-for="(item , i ) in form.data" :key="i" >
                <b-col cols="4">
                  <form-select
                    label="الدور"
                    v-model="item.transaction_role_id"
                    :getOptionLabel="(x) => x.name"
                    :reduce="(x) => x.id"
                    :id="`activity_${i}`"
                    :ep="roleEp"
                    rules="required"
                    ref="activity"
                  />
                </b-col>
                <b-col cols="4">
                  <form-select
                      label="المحافظة"
                      v-model="item.governorate_id"
                      :getOptionLabel="(x) => x.name_ar"
                      :reduce="(x) => x.id"
                      :id="`governorate_${i}`"
                      ep="v2/guest/selects/governorates"
                      rules="required"
                      ref="governorate_id"
                      :closeOnSelect="false"
                  />
                </b-col>
                <b-col cols="3">
                  <form-select
                    label="المعاملة"
                    v-model="item.transaction_type_id"
                    :getOptionLabel="(x) => x.name"
                    :reduce="(x) => x.id"
                    :id="`transaction_type_${i}`"
                    ep="v2/ministry/selects/transaction-types"
                    rules="required"
                    ref="transaction_type"
                    multiple
                    :closeOnSelect="false"
                  />
                </b-col>
                <b-col cols="1" class="d-flex justify-content-end align-items-center mt-1">
                  <b-button
                    variant="outline-danger"
                    :disabled="i===0 && form.data.length === 1"
                    @click="onClickedDelete(i)"
                  >
                    <feather-icon icon="XIcon" />
                    حذف
                  
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
            <b-col cols="12" v-if="!ifEdit">
              <b-button
                variant="success"
                @click="onClickedAdd"
                class="my-2"
              >
                <feather-icon icon="PlusIcon" />
                إضافة
              
              </b-button>
            </b-col>
           
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
  BSkeleton
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
const initForm = {
  data:[{}]
};

export default {
  components: {
    ValidationObserver,
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormCheckbox,
    BFormCheckboxGroup,
    BSkeleton
  },
  props: {
    value: Boolean,
    title: { type: String, default: () => "إضافة دور طلب معاملة" },
    btnLabel: { type: String, default: () => "حفظ" },
    loading: Boolean,
    
    ifEdit : {
      type: Boolean,
      default: () => false,
    },
    activityName: {
      type: String,
      default: () => null,
    },
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
    id: {
      type: Number,
      default: () => null,
    },
    loadingTransictionRole :{
      type: Boolean,
      default: () => false,

    }
  },
  data() {
    return {
      form: {},
      ministry_user_id: null,
      selected: [],
      required,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    roleEp() {
      return this.ministry_user_id || this.ministry_user_id === 0
        ? "v2/ministry/selects/transaction-roles?ministry_user_id=" + this.ministry_user_id
        : "v";
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
    id(val){
      this.ministry_user_id = val
    },
    
    roleEp(newVal) {
      if (this.$refs.activity && this.roleEp.length > 1)
        this.$refs.activity[0].refreshOptions(newVal);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    onUrgentChecked(val) {
      if (val) this.ministry_user_id = 0;
      else this.ministry_user_id = null;
    },
    saveTransictionRole() {
      this.$refs.activityValidation.validate().then((success) => {
        if (success) {
          this.form.ministry_user_id = this.ministry_user_id
          this.$emit("confirm", this.form);
        }
      });
    },
    onClickedAdd(){
      if(!this.form.hasOwnProperty('data') || Object.keys(this.form.data).length === 0 ){
    
        this.form.data =[{}]
      }
      else{
        
        // check if any form station => open without save Data
        let i=0
        if(this.form.data.length === 0)
        {
          this.form.data.push({})
        }
        
        else{
          for(let item of this.form.data)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.data.splice(i-1, 1) 
            }
        
        
          }
          this.form.data.push({})
        }

      

      }
    },
    onClickedDelete(i){
      this.form.data.splice(i, 1) 
      
      this.$refs.activity[0].refreshOptions(this.roleEp);

    }
  },
};
</script>

<style lang="scss">
.checkbox-cont {
  .bv-no-focus-ring {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}
</style>
